export default __webpack_public_path__ + "static/f63f2f28de489db9d519f2a25df365fe.jpg";